import { render, staticRenderFns } from "./dialog-upload.vue?vue&type=template&id=1372c784&"
import script from "./dialog-upload.vue?vue&type=script&lang=ts&"
export * from "./dialog-upload.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports